import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularFireAuthModule } from 'angularfire2/auth';
import { AuthService } from './auth.service';


@NgModule({
  imports: [
    CommonModule,
    AngularFireAuthModule,
    
  ],
  providers: [AuthService],
  declarations: []
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts